import { Plus, Edit, Trash2, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
function ActivityEntry() {
  const [showNonContractSection, setShowNonContractSection] = useState(false);
  const activities = [
    {
      id: 1,
      jacket: "JKT-2026-001",
      invoiceDescription: "Pallet Storage - Standard",
      quantity: 25,
      unit: "Pallets",
      comments: "Monthly storage allocation"
    },
    {
      id: 2,
      jacket: "JKT-2026-003",
      invoiceDescription: "Order Processing - Standard",
      quantity: 800,
      unit: "Orders",
      comments: "March order volume"
    },
    {
      id: 3,
      jacket: "JKT-2026-001",
      invoiceDescription: "Labor Hours - Warehouse TEST",
      quantity: 13.5,
      unit: "Hours",
      comments: "Special project hours"
    },
    {
      id: 4,
      jacket: "JKT-2026-016",
      invoiceDescription: "Outbound Shipping",
      quantity: 450,
      unit: "Shipments",
      comments: "Q1 shipping activity"
    },
    {
      id: 5,
      jacket: "JKT-2026-003",
      invoiceDescription: "Inbound Receiving",
      quantity: 320,
      unit: "Receipts",
      comments: "Standard receiving"
    },
    {
      id: 6,
      jacket: "JKT-2026-001",
      invoiceDescription: "Cycle Count Services",
      quantity: 12,
      unit: "Counts",
      comments: "Monthly cycle count"
    }
  ];
  return <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Monthly Activity Entry</h1>
        <p className="text-gray-600 dark:text-gray-400">Enter operational activity for billing</p>
      </div>

      {
    /* Filters */
  }
      <div className="mb-6 grid grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Client
          </label>
          <select className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
            <option>All Clients</option>
            <option>Acme Corporation</option>
            <option>Global Tech Inc</option>
            <option>Stellar Industries</option>
            <option>NextGen Solutions</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Service Month
          </label>
          <input
    type="month"
    defaultValue="2026-03"
    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Jacket Number
          </label>
          <select className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
            <option>All Jackets</option>
            <option>JKT-2026-001</option>
            <option>JKT-2026-003</option>
            <option>JKT-2026-016</option>
          </select>
        </div>
      </div>

      {
    /* Activity Transactions Table */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Jacket
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Invoice Description
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Quantity
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Unit
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Comments
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
              {activities.map((activity) => <tr key={activity.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                    {activity.jacket}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                    {activity.invoiceDescription}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                    {activity.quantity}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                    {activity.unit}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                    {activity.comments}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <div className="flex items-center gap-2">
                      <button className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
                        <Edit className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      </button>
                      <button className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
                        <Trash2 className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {
    /* Non-Contract Activity Section - Collapsible */
  }
      <div className="mt-6 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
        <button
    onClick={() => setShowNonContractSection(!showNonContractSection)}
    className="app-btn-plain w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-gray-900 dark:text-gray-100"
  >
          <div className="flex items-center gap-3">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Activity Not Tied to Contract
            </h2>
            <span className="px-2 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs rounded">
              Optional
            </span>
          </div>
          {showNonContractSection ? <ChevronUp className="w-5 h-5 text-gray-600 dark:text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-600 dark:text-gray-400" />}
        </button>

        {showNonContractSection && <div className="border-t border-gray-200 dark:border-gray-700">
            <div className="p-6">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                Enter activity for services not associated with a specific contract or agreement.
              </p>

              {
    /* Action Button */
  }
              <div className="mb-4">
                <button className="app-btn-gloss">
                  <Plus className="w-5 h-5" />
                  Add Non-Contract Activity
                </button>
              </div>

              {
    /* Non-Contract Activity Table */
  }
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                        Jacket
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                        Service Code
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                        Quantity
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                        Unit
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                        Comments
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
                    <tr className="text-center">
                      <td colSpan={6} className="px-6 py-8 text-sm text-gray-500 dark:text-gray-500">
                        No non-contract activity entries. Click "Add Non-Contract Activity" to add one.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}
export {
  ActivityEntry
};
